import { ZodNoCyrillicString } from '@Common/types/zod/zod-no-cyrillic-string';

export const ZodFlatBuilding = ZodNoCyrillicString.regex(
  /^[ 0-9-'"–.,()/&\p{Letter}+@\\$%#>;:°]*$/iu,
).max(255);

export const ZodCity = ZodNoCyrillicString.regex(/^[ 0-9-'–.,\p{Letter}('"%$#&)>;:@°/\\+]*$/iu)
  .min(1)
  .max(255);

export const ZodStreet = ZodNoCyrillicString.min(2).max(255);
